import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaStar, FaFacebook, FaTwitter, FaLinkedin } from "react-icons/fa";
import {
  team1,
  team2,
  team3,
  client1,
  client2,
  client3,
  client4,
  client5,
  client6,
  productOfTheYear,
} from "../../assets/images/index"; 

const About = () => {
  const location = useLocation();
  const [prevLocation, setPrevLocation] = useState("");

  useEffect(() => {
    AOS.init();
    if (location.state && location.state.data) {
      setPrevLocation(location.state.data);
    } else {
      setPrevLocation("Home");
    }
  }, [location]);

  const teamMembers = [
    { name: "Marvin McKinney", role: "Marketing Team", imgSrc: team1 },
    { name: "Kathryn Murphy", role: "Marketing Team", imgSrc: team2 },
    { name: "Darrell Steward", role: "Marketing Team", imgSrc: team3 },
  ];

  return (
    <div className="max-w-container mx-auto px-4 sm:px-8 md:px-16 lg:px-24">
      
      <div className="relative w-full h-[400px]">
        <img
          src={productOfTheYear} 
          alt="About Banner"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <h1 className="text-4xl font-bold text-white">About Us</h1>
        </div>
      </div>

      <Breadcrumbs title="About" prevLocation={prevLocation} />

      <section className="about-us-section py-10 text-center md:text-left flex flex-col-reverse md:flex-row items-center">
        <div className="text-section md:w-1/2">
          <h2 className="text-3xl font-bold text-primeColor mb-4">Who We Are</h2>
          <p className="text-gray-700 mb-6">
            Our store, Harvel Electric, is a trusted destination for electric
            home appliances, offering a wide range of products including air
            conditioners, fans, geysers, refrigerators, dispensers, and more. We
            prioritize quality over profit, which is why our name is well-known
            in the market. We always strive to meet our customers' expectations
            and ensure they receive the best in both products and service.
          </p>
        </div>
        <div className="image-section md:w-1/2 mb-6 md:mb-0">
          <img
            src={productOfTheYear} 
            alt="Harvel Electric product of the year"
            className="w-full h-full object-cover rounded-lg"
          />
        </div>
      </section>

      <section className="team-section py-10">
        <h2 className="text-3xl font-bold text-primeColor text-center mb-8">
          Meet Our Team
        </h2>
        <div className="flex flex-wrap justify-center gap-6">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="w-full sm:w-1/2 lg:w-1/4 text-center p-6 bg-white rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105"
              data-aos="fade-up"
            >
              <img
                src={member.imgSrc}
                alt={member.name}
                className="w-28 h-28 rounded-full mx-auto mb-4 border-4 border-primeColor"
              />
              <h4 className="text-lg font-semibold">{member.name}</h4>
              <p className="text-sm text-gray-600">{member.role}</p>
              <div className="flex justify-center mt-2 space-x-3">
                <a
                  href="https://facebook.com"
                  className="text-gray-500 hover:text-primeColor transition duration-200"
                >
                  <FaFacebook />
                </a>
                <a
                  href="https://twitter.com"
                  className="text-gray-500 hover:text-primeColor transition duration-200"
                >
                  <FaTwitter />
                </a>
                <a
                  href="https://linkedin.com"
                  className="text-gray-500 hover:text-primeColor transition duration-200"
                >
                  <FaLinkedin />
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="feedback-section py-10 bg-gray-100">
        <h2 className="text-3xl font-bold text-primeColor text-center mb-8">
          Clients Feedback
        </h2>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {[client1, client2, client3, client4, client5, client6].map(
            (feedback, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-lg shadow-md text-center"
                data-aos="fade-up"
              >
                <img
                  src={feedback}
                  alt={`Client Feedback ${index + 1}`}
                  className="w-24 h-24 rounded-full mx-auto mb-4"
                />
                <h4 className="font-semibold text-lg">Client {index + 1}</h4>
                <p className="text-sm text-gray-600">Client Role</p>
                <p className="text-gray-700 mt-3">
                  "I am very happy with the services provided by the team. They
                  were professional and attentive to every detail."
                </p>
                <div className="flex justify-center mt-3 space-x-1">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} className="text-yellow-500" />
                  ))}
                </div>
              </div>
            )
          )}
        </div>
      </section>
    </div>
  );
};

export default About;
